import React from 'react';
import { Numbers } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import css from '../../../styles.module.css';

export default function Rate({ rate, form }) {
    const { language: locale } = i18n;
    const { t } = useTranslation();
    const { currency } = form;

    const loadCss = React.useMemo(() => {
        if (form.use_sessions) {
            return 'summary-ticket';
        }

        if (form.use_inventories) {
            return 'summary-ticket';
        }

        return 'summary-ticket-basic';
    }, [form]);

    const totalPrice = React.useMemo(() => {
        return rate.quantity * rate.price;
    }, [rate.quantity, rate.price]);

    return (
        <div className={css[loadCss]}>
            <div>
                {rate.quantity} x {rate.rate.getName()} + {t('ticket.common.fees')}
            </div>
            <Numbers className={css['summary-price']} value={totalPrice} locale={locale} currency={currency} showNullDecimal />
        </div>
    );
}
